import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import FormElement from '..';

import './index.css';

const LabelDecorator = (props) => {
  const {
    className, children, label, showLabel,
  } = props;
  const classNames = classnames({
    LabelDecorator: true,
    [className]: true,
    showLabel,
  });
  const { name } = children.props;
  return (
    <FormElement className={classNames}>
      {children.props.readOnly && <div className="disabled-overlay" />}
      <label htmlFor={name}>
        {<div className="label">{label}</div>}
        {children}
      </label>
    </FormElement>
  );
};

LabelDecorator.propTypes = {
  children: PropTypes.node.isRequired, // Should be a NormalizedInput
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  showLabel: PropTypes.bool,
};

LabelDecorator.defaultProps = {
  className: '',
  showLabel: true,
};

export default LabelDecorator;
